const e = "styles-module__header___ooChC", _ = "styles-module__header_content___CNPGN", t = "styles-module__header_content_left___kFg-R", o = "styles-module__back___0i1te", n = {
  header: e,
  header_content: _,
  header_content_left: t,
  back: o
};
export {
  o as back,
  n as default,
  e as header,
  _ as header_content,
  t as header_content_left
};
